import * as React from 'react';
import * as acl from 'common/utils/acl';

import { AppState } from 'common/models/AppState';
// import { Datetime } from 'common/components/Datetime';
import { EntityActions } from 'common/entity';
import { InfiniteList } from 'common/components/InfiniteList';
import { Loading } from 'common/components/Loading';
import { RowActionButton } from '../../common/components/RowActionButton';
import { Table } from 'reactstrap';
import { SummitRegistrant } from 'common/api/models/SummitRegistrant';
import { SummitRegistrantApi } from '../../common/api/resources/SummitRegistrantApi';
import { User } from 'common/api/models/User';
import { toApiError } from 'common/utils/api';
import { stripQueryTerms, getQueryTerm } from 'common/utils/search';

interface SummitRegistrantsTableProps {
  appState: AppState;
  entityActions: EntityActions;
  query: string;
  onEdit: (user: User) => void;
}
interface SummitRegistrantsTableState {
  summitRegistrants: SummitRegistrant[];
  next?: string;
  isLoading: boolean;
  error?: string;
}
export class SummitRegistrantsTable extends React.Component<SummitRegistrantsTableProps, SummitRegistrantsTableState> {
  state: SummitRegistrantsTableState = { summitRegistrants: [], isLoading: true };

  handleLoadMore = () => {
    this.reload(this.props.query, this.state.next);
  };

  componentDidMount() {
    this.reload(this.props.query);
  }

  componentDidUpdate(prevProps: SummitRegistrantsTableProps) {
    if (prevProps.query !== this.props.query) {
      this.reload(this.props.query);
    }

    if (prevProps.appState !== this.props.appState) {
      this.reload(this.props.query);
    }
  }

  reload(search: string, from?: string) {
    this.setState({ isLoading: true });

    const q = stripQueryTerms(search, ['type']);
    const type = getQueryTerm(search, 'type');

    SummitRegistrantApi.findSummitRegistrants({ q, type, from: from }).then(
      results => {
        this.setState(prevState => ({
          ...prevState,
          summitRegistrants: from ? prevState.summitRegistrants.concat(results.data!) : results.data!,
          next: results.next,
          error: undefined,
          isLoading: false,
        }));
      },
      err => {
        this.setState({ error: toApiError(err), isLoading: false });
      }
    );
  }

  render() {
    const cols = 4;

    return (
      <InfiniteList hasMore={!!this.state.next} isLoading={this.state.isLoading} onLoadMore={this.handleLoadMore}>
        {this.state.error && (
          <div className="alert alert-danger" style={{ marginTop: 20 }}>
            {this.state.error}
          </div>
        )}

        <Table className="table-clickable" responsive={true} hover={true} striped={true}>
          <thead>
            <tr>
              <th>Email</th>
              <th>First Name</th>
              <th>Last Name</th>
              <th>Third Party</th>
              <th>Is Member?</th>
              <th>Summit ID</th>
            </tr>
          </thead>
          <tbody>
            {!this.state.isLoading && !this.state.error && this.state.summitRegistrants.length === 0 && (
              <tr>
                <td colSpan={cols}>No results found.</td>
              </tr>
            )}
            {this.state.summitRegistrants.map(t => (
              <tr key={t.id} data-id={t.id}>
                <td>{t.email}</td>
                <td>{t.firstName}</td>
                <td>{t.lastName}</td>
                <td>{t.thirdParty}</td>
                <td>{t.isMember ? 'Yes' : 'No'}</td>
                <td>{t.summitId}</td>
                <td>
                  {acl.isManager(this.props.appState.user!) && (
                    <RowActionButton item={t} icon="pencil" onClick={this.props.onEdit} />
                  )}
                </td>
              </tr>
            ))}
            {this.state.isLoading && (
              <tr>
                <td colSpan={cols}>
                  <Loading />
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </InfiniteList>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/SummitRegistrants/SummitRegistrantsTable.tsx